import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import BackgroundImage from './BackgroundImage';
import Notification from './Notification';
import Unlink from './Unlink';
import Hero from './Hero';
import Banner from './Banner';
import GetStarted from './GetStarted';
import Videos from './Videos';
import Selection from './Selection';
import Stats from './Stats';
import GoogleTranslate from './GoogleTranslate';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  $('.block.overview .node', context).each((i, element) => {
    const $links = $('.node-links', element);
    const $content = $('.node-content', element);
    if ($links.length > 0) {
      $links.each((j, link) => {
        const $link = $('.link:not(.link-read-more) a', link);
        const $href = $link.attr('href');
        if ($(`a[href="${$href}"]`, $content).length > 0) {
          $link[0].closest('li.link').remove();
        }
      });
    }
  });

  // Selection Dropdown Lists
  $('.videos-by-topic, .member-pods .node', context).each((i, element) => {
    if (!element.Selection) {
      element.Selection = new Selection(element);
    }
  });

  // How Do I? Selection Dropdown List
  $('.how.block', context).each((i, element) => {
    if (!element.Selection) {
      element.Selection = new Selection(element, {
        defaultText: 'How Do I?',
        addReadMore: false,
      });
    }
  });

  // Hero Banner
  $('.hero.banner', context).each((i, element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Term Banner
  $('.term.banner', context).each((i, element) => {
    if (!element.Banner) {
      element.Banner = new Banner(element);
    }
  });

  // Member Pods
  $('#block-views_blocks-term-block_1-8 .node-header a', context).each((i, element) => {
    if (!element.Unlink) {
      element.Unlink = new Unlink(element);
    }
  });

  // Get Started Homepage Block
  $('#block-views_blocks-term-block_1-10', context).each((i, element) => {
    if (!element.GetStarted) {
      element.GetStarted = new GetStarted(element);
    }
  });

  // Featured Videos Carousel
  $('#block-views_blocks-term-block_1-11', context).each((i, element) => {
    if (!element.Videos) {
      element.Videos = new Videos(element);
    }
  });

  // Videos by Topic
  $('#block-views_blocks-term-block_1-12 .node-header a', context).each((i, element) => {
    if (!element.Unlink) {
      element.Unlink = new Unlink(element);
    }
  });

  // Stats
  $('#block-views_blocks-term-block_1-13', context).each((i, element) => {
    if (!element.Stats) {
      element.Stats = new Stats(element);
    }
  });

  // Header helper
  const $top = $('.page-top', context);
  const $blocks = $top.find('div:not(.placeholder-block)');

  // add header class to force the show of bottom border
  if (!$blocks.length) {
    $('.page-header', context).addClass('top-empty');
  }

  // Pods
  $('.pods.block .views-row', context).each((i, element) => {
    if (!element.BackgroundImage) {
      element.BackgroundImage = new BackgroundImage(element, { target: '.node' });
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Site Notifications
  $('#block-views_blocks-term-block_1-5:not(.placeholder-block)', context).each((i, element) => {
    if (!element.Notification) {
      element.Notification = new Notification(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Calendar of Events View
  $('#maryland-translate', context).each((i, element) => {
    if (!element.GoogleTranslate) {
      element.GoogleTranslate = new GoogleTranslate(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});
